<template>
  <div>
    <img
      :src="gif.src"
      :style="`width: ${gif.width}; height: ${gif.height};`"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      gif: {
        width: "200px",
        height: "200px",
        src: require("@/assets/verification_circle.gif"),
      },
      successGif: {
        width: "100px",
        height: "100px",
        src: require("@/assets/verification_complete.gif"),
      },
    };
  },
  async mounted() {
    await store.dispatch("user/logout");
    await this.verifyUser();
  },
  methods: {
    getUrlQuery(key) {
      return this.$route.query[key];
    },
    async verifyUser() {
      try {
        const new_user_token = this.getUrlQuery("new_user_token");
        const data = {
          token: new_user_token,
        };
        await store.dispatch("userManagement/confirmSignedUpUser", data);
        this.gif = this.successGif;
        setTimeout(() => {
          this.$router.push("/");
        }, 2000);
      } catch (e) {
        Vue.prototype.$notify.error({
          title: "Server Error",
          message: e.response.data.message,
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
      }
    },
  },
};
</script>
